'use client';

import useStyles from './styles';
import type { WithChildren, WithDataTestId } from './types';

const PresetMain = ({ children, dataTestId }: WithDataTestId) => {
  const classes = useStyles();
  return (
    // `data-app-shell` marks this route as one that fills the viewport and
    // scrolls internally. `globals.css` keys the document's own overflow off it
    // — see the rule there for why it cannot live in this stylesheet.
    //
    // The embedded miniapp wants this too: it is an app shell in its own right,
    // and its panels size with `height: 100%`, which collapses inside an
    // auto-height page.
    <main className={classes.main} data-app-shell data-testid={dataTestId}>
      {children}
    </main>
  );
};

export const PresetCrumbWrap = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <div className={classes.crumbWrap}>{children}</div>;
};

export const PresetBody = ({ children }: WithChildren) => {
  const classes = useStyles();
  return <div className={classes.body}>{children}</div>;
};

export default PresetMain;
